import { render, staticRenderFns } from "./leftMenu.vue?vue&type=template&id=54f82b82&scoped=true"
import script from "./leftMenu.vue?vue&type=script&lang=js"
export * from "./leftMenu.vue?vue&type=script&lang=js"
import style0 from "./leftMenu.vue?vue&type=style&index=0&id=54f82b82&prod&scoped=true&lang=css"
import style1 from "./leftMenu.vue?vue&type=style&index=1&id=54f82b82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f82b82",
  null
  
)

export default component.exports